import React from "react";
import { PlatformWrap, Title, SubTitle, Text, Slider } from "./styled";

const Platform = () => {
  return (
    <PlatformWrap>
      <Title>
        A platform as diverse as the
        <SubTitle color="red"> real world</SubTitle>
      </Title>
      <Text>
        Foody's vision is to give creators of every culture, race, religion, nationality, sexual orientation and gender
        identity an equal opportunity to share their culinary creativity with the world and be paid for it.
      </Text>
      <Slider />
    </PlatformWrap>
  );
};

export default Platform;
